// extracted by mini-css-extract-plugin
export var productImage = "_nt-1";
export var viewLink = "_nt-2";
export var wishlistItem = "_nt-0";